const getOptions = function (vizCount) {
  const options = Array.from({ length: vizCount })
    .fill()
    .map((_, index) => index + 1);
  return [
    { type: 'string', enum: ['none'], title: 'None' },
    ...options.map((num) => ({
      type: 'number',
      enum: [num],
      title: num,
    })),
  ];
};
const getVisualizationSettingsSchema = (vizCount = 5) => ({
  type: 'object',
  properties: {
    priority: {
      type: ['number', 'string'],
      title: 'Priority',
      anyOf: getOptions(vizCount),
    },
  },
});

export default getVisualizationSettingsSchema;
